import React, { useState } from "react";
import { OnboardingFlow } from "../../../components/marketing/contact/on-boarding";

const SMSResellerPlatform = () => {
  const [currentView, setCurrentView] = useState("onboarding");
  const [userRole, setUserRole] = useState("admin");
  const [currentUserId, setCurrentUserId] = useState(1);

  return (
    <div>
      <OnboardingFlow setCurrentView={setCurrentView} />
    </div>
  );
};

export default SMSResellerPlatform;
